<template>
	<div>
        <ValidationObserver ref="formModalValidate">
            <b-row>
                <b-col cols="12" md="6">
                    <ValidationProvider name="type" rules="required" v-slot="{valid, errors}">
                        <b-form-group :label="$t('type')">
                            <parameter-selectbox
                                :validate-error="errors[0]"
                                code="budget_payment_types"
                                v-model="formData.type"
                            ></parameter-selectbox>
                        </b-form-group>
                    </ValidationProvider>
                </b-col>
                <b-col cols="12" md="6">
                    <ValidationProvider name="payment_date" rules="required" v-slot="{ valid, errors }">
                        <b-form-group :label="$t('payment_date')">
                            <select-date v-model="formData.payment_date" :is-time="false" :state="errors[0] ? false : null" />
                            <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]" />
                        </b-form-group>
                    </ValidationProvider>
                </b-col>
                <b-col cols="12" md="6">
                    <ValidationProvider name="amount" rules="required" v-slot="{valid, errors}">
                        <b-form-group :label="$t('amount')">
                            <b-form-input
                                type="number"
                                min="0" step=".01"
                                v-check-min-max-value
                                v-model="formData.amount"
                            ></b-form-input>
                            <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]"></b-form-invalid-feedback>
                        </b-form-group>
                    </ValidationProvider>
                </b-col>
                <b-col cols="12" md="6">
                    <ValidationProvider name="explanation" rules="required" v-slot="{errors}">
                        <b-form-group :label="$t('explanation')">
                            <b-form-textarea v-model="formData.explanation"
                                             :class="errors[0] ? 'is-invalid':''"
                                             rows="6" />
                            <span class="invalid-feedback-custom" v-show="errors[0]" v-html="errors[0]"/>
                        </b-form-group>
                    </ValidationProvider>
                </b-col>
            </b-row>
            <div class="d-flex justify-content-center mt-2">
                <b-button variant="primary"
                          @click="createForm"
                          :disabled="formLoading">
                    {{ $t('save') }}
                </b-button>
            </div>
        </ValidationObserver>
	</div>
</template>

<script>
	// Components
    import ParameterSelectbox from "@/components/interactive-fields/ParameterSelectbox.vue";
    import CustomerBudgetsSelectbox from "@/components/interactive-fields/CustomerBudgetsSelectbox.vue";

    // Services
    import CustomerBudgetPaymentService from "@/services/CustomerBudgetPaymentService";

	// Other
	import {ValidationProvider, ValidationObserver} from "vee-validate"

	export default {
		components: {
            ParameterSelectbox,
            CustomerBudgetsSelectbox,

            ValidationProvider,
            ValidationObserver,
		},
        props: {
            formId: {
                type: Number
            }
        },
		data() {
			return {
				formData: {
                    customer_budget_id: this.formId,
                    payment_date: null,
                    amount: null,
                    type: null,
                    explanation: null,
				},
				formLoading: false,
			}
		},
		methods: {
			async createForm() {
				const isValid = await this.$refs.formModalValidate.validate();
				if (isValid) {
					this.formLoading = true;
					CustomerBudgetPaymentService.store(this.formData)
					             .then(response => {
						             this.$toast.success(this.$t('api.' + response.data.message));
						             this.$emit('createFormSuccess', true);
					             })
					             .catch(e => {
						             this.showErrors(e, this.$refs.formModalValidate);
					             })
					             .finally(() => {
						             this.formLoading = false
					             })
				}
			}
		}
	}
</script>

